jQuery(document).ready(function ($) {
    "use strict";

    // Enable smooth anchor link scrolling
    // on all link elements (href="#...")
    $.localScroll({
        target: 'body',
        offset: -($('.main-header').outerHeight() + 50)
    });

    $('[data-link]').on('click', function (e) {
        e.preventDefault();
        var did = $(this).data('link');
        
        // Check if the clicked element or any of its ancestors have data-tab-navigation attribute
        if ($(this).closest('[data-tab-navigation]').length === 0) {
            // The clicked element is not inside a data-tab-navigation element
            $('div' + did).toggleClass('is-active');
    
            if (did !== "#mini-cart" && did !== "#mobilemenu" && did !== "#popupsearch") {
                $('body').toggleClass('overflow-hidden');
            }
    
            if (did == "#popupsearch") {
                // Focus on the search input field
                setTimeout(function() {
                    $('.woocommerce-product-search__field--mobile').focus();
                }, 50); // Adjust the delay as needed
            }
        }
    });    

    // Tab functionality
    $('[data-tabs]').tabs();

    // Tab functionality
    $('[data-category-tabs]').categorytabs();

    $('[data-map]').gMap();

    // Opens Magnific Popup's, using the data attribute to group items into a gallery,
    // For dynamic type to work, you will need to add the class mfp-TYPE to all elements.
    // Use mfp-image for images, mfp-iframe for videos, and mfp-inline for HTML.
    /* Look at this further, can be more efficient. */
    $('[data-mfp]').on('click', function (e) {
        e.preventDefault();

        $('[data-mfp]').magnificPopup({
            gallery: {
                enabled: true
            }
        }).magnificPopup('open');
    });

    // Magnific popup for galleries
    $('.magnific-gallery').magnificPopup({
        type: 'image',
        gallery:{
            enabled:true
        }
    });

    // Reset button for WooCommerce search filters
    $('[data-clear-search]').on('click', function(e) {
        $('[data-search-element]').each(function(){
            $(this)[0].value = '';
        });

        $('[data-search-min]').each(function(){
            $(this)[0].value = '0';
        });

        $('[data-search-max]').each(function(){
            $(this)[0].value = '99999999';
        });
    });
});
